import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { isLayoutContentField } from '../constants';

/**
 * Basic properties component (Label, Placeholder, Help Text)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BasicProperties = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  const isLayoutField = isLayoutContentField(field.type);
  const isContainerField = ['section', 'columns'].includes(field.type);
  const excludePlaceholder = ['tabs'].includes(field.type);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [!isContainerField && /*#__PURE__*/_jsx(PropertyGroup, {
      label: "Field Label",
      children: field.type === 'paragraph' ? /*#__PURE__*/_jsx("textarea", {
        value: field.label,
        onChange: e => updateField(selectedField, {
          label: e.target.value
        }),
        className: "property-input",
        rows: 4,
        placeholder: "Enter paragraph text"
      }) : /*#__PURE__*/_jsx("input", {
        type: "text",
        value: field.label,
        onChange: e => updateField(selectedField, {
          label: e.target.value
        }),
        className: "property-input"
      })
    }), !isLayoutField && !isContainerField && !excludePlaceholder && /*#__PURE__*/_jsx(PropertyGroup, {
      label: "Placeholder",
      children: /*#__PURE__*/_jsx("input", {
        type: "text",
        value: field.placeholder || '',
        onChange: e => updateField(selectedField, {
          placeholder: e.target.value
        }),
        className: "property-input"
      })
    }), /*#__PURE__*/_jsx(PropertyGroup, {
      label: "Help Text",
      children: /*#__PURE__*/_jsx("textarea", {
        value: field.helpText || '',
        onChange: e => updateField(selectedField, {
          helpText: e.target.value
        }),
        className: "property-input",
        rows: 2
      })
    })]
  });
};